/**
 * Menu Vuex
 */
import * as API from '@/endpoints'
import Axios from 'axios'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    postSelectionDialogShow: false,
    postDocumentDialogShow: false,
    triggerPostSelection: false,
    selectedPlan: {},
    permitted: {
      list: {},
      isLoading: false
    },
    showWizardModalComponent: false,
    showReportModalComponent:{isShow:false, type:null}
  },
  mutations: {
    setPostSelectionPlan (state, v) {
      Vue.set(state, 'selectedPlan', v)
    },
    setPostSelectionModal (state, v) {
      Vue.set(state, 'postSelectionDialogShow', v)
    },
    setPermittedList (state, v) {
      Vue.set(state.permitted, 'list', v)
    },
    setPermittedListLoader (state, v) {
      Vue.set(state.permitted, 'isLoading', v)
    },
    setTriggerPostSelection (state, v) {
      Vue.set(state, 'triggerPostSelection', v)
    },
    setShowWizardModalComponent (state, v) {
      Vue.set(state, 'showWizardModalComponent', v)
    },
    setShowReportModalComponent (state, v) {
      Vue.set(state, 'showReportModalComponent', v)
    },
    setPostDocumentModal (state, v) {
      Vue.set(state, 'postDocumentDialogShow', v)
    },
  },
  actions: {
    getPermittedPlan ({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        commit('setPermittedListLoader', true)
        Axios.get(API.endpoints.permitted + '?brand_id=' + Cons[0].BRAND_ID)
          .then(res => {
            commit('setPermittedList', res.data)
            commit('setPermittedListLoader', false)
            resolve(res.data)
          }, error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setPermittedListLoader', false)
            reject(error)
          }
          )
      })
    }
  }
}
